import * as tslib_1 from "tslib";
import * as React from 'react';
import cn from 'astro-classname';
import WaterMarkSvg from './WaterMarkSvg';
var WaterMark = (function (_super) {
    tslib_1.__extends(WaterMark, _super);
    function WaterMark() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.wrapper = React.createRef();
        return _this;
    }
    WaterMark.prototype.componentDidMount = function () {
        this.renderWatermark();
    };
    WaterMark.prototype.renderWatermark = function () {
        var _this = this;
        var _a = this.props, width = _a.width, height = _a.height, text = _a.text, src = _a.src;
        var markImg = new Image();
        var res = new Image();
        res.src = src;
        markImg.crossOrigin = 'Anonymous';
        markImg.onload = function () {
            var img = new Image();
            var cwidth = width || markImg.width;
            var cheight = height || markImg.height;
            img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = cwidth;
                canvas.height = cheight;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(markImg, 0, 0, cwidth, cheight);
                ctx.drawImage(img, 0, 0);
                try {
                    res.src = canvas.toDataURL('image/png');
                }
                catch (e) {
                    console.error(e);
                }
            };
            img.src = WaterMarkSvg({ height: height, width: width, text: text });
            _this.wrapper.current && _this.wrapper.current.append(res);
        };
        markImg.src = res.src;
    };
    WaterMark.prototype.render = function () {
        var className = this.props.className;
        var classes = cn('zhui-watermark', className);
        return (React.createElement("div", { className: classes, ref: this.wrapper }));
    };
    WaterMark.defaultProps = {
        className: '',
        text: '水印'
    };
    return WaterMark;
}(React.Component));
export default WaterMark;
